import { render, staticRenderFns } from "./DxpFileList.vue?vue&type=template&id=6e57e668"
import script from "./DxpFileList.vue?vue&type=script&lang=js"
export * from "./DxpFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports